var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type==='default')?_c('div',{class:_vm.barClass,style:({
  'height': _vm.height,
  'width': _vm.percent+'%',
  'display': 'block'
})}):_c('div',{staticClass:"e-progress-bar"},[_c('div',{class:_vm.barClass,style:({
  'height': _vm.height,
  'width': '100%',
  'display': _vm.percent > 0 ? 'block' : 'none'
})},[_c('div',{staticClass:"progressbar bar bar1",staticStyle:{"width":"0%"}}),_c('div',{staticClass:"bufferbar bar bar2",staticStyle:{"width":"100%"}}),_c('div',{staticClass:"auxbar bar bar3",staticStyle:{"width":"0%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }